import React, {useState, useEffect} from 'react';
import {View, Button, ScrollView, Text} from 'react-native';
import useLocalNotification from '../hooks/localNotificationHandler';
import ReminderManager from '../modals/ReminderManager';
import ReminderDays from "./ReminderDays";
import styled from 'styled-components/native';
import useLocalNotificationJSONManager from '../hooks/useLocalNotificationJSONManager';
import { useFocusEffect } from '@react-navigation/native';
import Bugsnag from '@bugsnag/expo';
import {useSelector} from 'react-redux';
import {
    WorkoutsParent,
    WorkoutContainerText,
    WorkoutTextHeader,
    CerebrocoreCommonTextComponent,
    WorkoutContainerHeaderThree,
    WorkoutCommonButton,
    WorkoutTextSubHeader
} from '../styles/common-styles';


//IMG
import PlusImage from '../../assets/plus.png';
import TrashImage from '../../assets/trash.png';
import ClockImage from '../../assets/clock.png'

// Assume ReminderItem and ButtonContainer are defined here or imported

function Reminders() {
    const {userId} = useSelector((state) => state.cbcAuthorization);
    const [modalVisible, setModalVisible] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [localNotificationGroups, setLocalNotificationGroups] = useState([]);
    const [editingNotification, setEditingNotification] = useState();
    const {
        scheduleNotification,
        scheduleRecurringNotification,
        getAllScheduledNotifications,
        cancelNotification
    } = useLocalNotification();
    const {
        notificationGroups,
        createNotificationGroup,
        updateNotificationGroup,
        deleteNotificationGroup,
        loadNotificationGroups,
        saveNotificationGroups,
        createNotificationGroupFromDetails
    } = useLocalNotificationJSONManager();

    const dayMap = {
        'Sunday': 1,
        'Monday': 2,
        'Tuesday': 3,
        'Wednesday': 4,
        'Thursday': 5,
        'Friday': 6,
        'Saturday': 7,
    };

    const numericDayMap = {
        1: 'Sunday',
        2: 'Monday',
        3: 'Tuesday',
        4: 'Wednesday',
        5: 'Thursday',
        6: 'Friday',
        7: 'Saturday',
    };

    useFocusEffect(
        React.useCallback(() => {
            return () => {
                Bugsnag.setUser(userId);
                const getLocalPushNotifications = async () => {
                    const localNotifs = await getAllScheduledNotifications();
                    Bugsnag.notify(
                        'User Local Notifications' + JSON.stringify(localNotifs)
                    );

                    Bugsnag.notify(
                        'User Local Notifications Groups' + JSON.stringify(localNotificationGroups)
                    );
                }
                getLocalPushNotifications();
            };
        }, [])
    );

    useEffect(() => {
        const getLocalPushNotifications = async () => {
            const localNotifs = await getAllScheduledNotifications();
            console.log('localNotifs: ', JSON.stringify(localNotifs));
            localNotifs.forEach((item) => {
                // console.log(item.identifier);
                // cancelNotification(item.identifier);
            })
        }
        getLocalPushNotifications();
    }, [])

    useEffect(() => {
        if (typeof editingNotification !== "undefined") {
            setModalVisible(true);
        }
    }, [editingNotification])

    useEffect(() => {
        setLocalNotificationGroups(notificationGroups);
    }, [notificationGroups]);


    useEffect(() => {
        if (localNotificationGroups.length !== 0) {
        }
    }, [localNotificationGroups]);

    const handleAddOrEditNotification = async (groupId = null) => {
        if (groupId) {
            console.log('groupId', groupId)

            const groupToEdit = localNotificationGroups.find(group => group.id === groupId);
            if (!groupToEdit) {
                console.warn("Notification group not found");
                return;
            }

            console.log('groupToEdit', groupToEdit);

            setEditingNotification({
                id: groupToEdit.id, // Keep track of the group's ID
                time: groupToEdit.time,
                days: groupToEdit.days.map(day => numericDayMap[day]),
                editingMode: true
            });

        } else {
            setEditingNotification(null); // Clear data for adding a new notification
            setModalVisible(true);
        }
    };

    const handleSaveNotification = async (selectedTime, selectedDays) => {
        setEditingNotification(undefined);
        const numericDays = selectedDays.map(day => dayMap[day]);
        console.log('TIME: ', selectedTime);

        try {
            if (editingNotification && editingNotification.id) {
                await handleCancelNotificationGroup(editingNotification.id)
            }
            const notifications = await scheduleRecurringNotification("Workout Reminder", false, selectedTime, numericDays);
            const newGroup = await createNotificationGroupFromDetails(notifications);

        } catch (error) {
            console.error("Failed to save notification:", error);
            // Optionally, implement a rollback mechanism or notify the user here
        }
    };

    const handleCancelNotificationGroup = async (groupId) => {
        const groupToDelete = localNotificationGroups.find(group => group.id === groupId);
        if (groupToDelete) {
            for (const identifier of groupToDelete.identifiers) {
                await cancelNotification(identifier);
            }
            await deleteNotificationGroup(groupId);
        }
    };

    function convertTime24to12(time24) {
        const [hours24, minutes] = time24.split(':').map(Number); // Convert to numbers

        let hours12 = hours24 % 12;
        if (hours24 === 0 || hours24 === 12) { // Midnight or Noon special case
            hours12 = 12;
        }

        const ampm = hours24 < 12 ? 'AM' : 'PM';
        const formattedTime = `${hours12.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${ampm}`;
        return formattedTime;
    }

    return (
        <NotificationManagerParent>
            <NotificationManagerBGImage
                source={{ uri: 'https://dev.cerebrocoreusa.com/wp-content/plugins/advanced-healthcare-solutions/media/backgrounds/Cerebrocore_workout-bkg-weight.png' }}
            />

            <NotificationManagerHeaderParent>
                <NotificationManagerHeaderClockImg
                    source={ClockImage}
                />
                <NotificationManagerHeaderText>REMINDERS</NotificationManagerHeaderText>
            </NotificationManagerHeaderParent>

            <AddReminderParent onPress={() => handleAddOrEditNotification()}>
                <AddReminderPlus
                    source={PlusImage}
                />

                <AddReminderText>ADD NEW REMINDER</AddReminderText>
            </AddReminderParent>
            <NotificationList key={notificationGroups.length}>
                {localNotificationGroups.map(group => (
                    <NotificationDisplay key={group.id} onPress={() => handleAddOrEditNotification(group.id)}>

                        <NotificationDisplayTop>
                            <NotificationDisplayHeader>REMINDER</NotificationDisplayHeader>
                            <NotificationDisplayTextTime>{convertTime24to12(group.time)}</NotificationDisplayTextTime>

                            <NotificationDisplayButtonCancel onPress={() => handleCancelNotificationGroup(group.id)}>
                                <NotificationDisplayButtonImg
                                    source={TrashImage}
                                />
                            </NotificationDisplayButtonCancel>
                        </NotificationDisplayTop>

                        <NotificationDisplayBottom>
                            <ReminderDays days={group.days.map(day => numericDayMap[day])}></ReminderDays>
                        </NotificationDisplayBottom>

                    </NotificationDisplay>
                ))}
            </NotificationList>

            <ReminderManager
                modalVisible={modalVisible}
                setModalVisible={setModalVisible}
                onSave={handleSaveNotification}
                initialTime={editingNotification?.time || '00:00'}
                initialDays={editingNotification?.days || []}
                editingMode={editingNotification?.editingMode}
            />
        </NotificationManagerParent>
    );
}

const NotificationManagerParent = styled.View`
  padding-left:30px;
  padding-right:30px;
  padding-top:30px;
  background-color:#282F63;
  height: 100%;
  position: absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
`;

const NotificationManagerBGImage = styled.Image`
  width:100%;
  height:400px;
  position: absolute;
  top:-65px;
  left:25px;
`;

const NotificationManagerHeaderParent = styled.View`
  margin-top:30px;
  margin-bottom:40px;
`;

const NotificationManagerHeaderClockImg = styled.Image`
  width:50px;
  height:50px;
`;

const NotificationManagerHeaderText = styled.Text`
  color: #C04C97;
  font-family: 'Montserrat-EB';
  font-size:19px;
  margin-top:5px;
`;

const AddReminderParent = styled.TouchableOpacity`
  display:flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  margin-left:5px;
`;

const AddReminderPlus = styled.Image`
  width:20px;
  height:20px;
`;

const AddReminderText = styled.Text`
  font-family: 'Montserrat-EB';
  font-size:16px;
  color:white;
  margin-left:10px;
`;

const NotificationList = styled.ScrollView`
  margin-top:20px;
  height: 100%;
  width: 100%;
`;

export const NotificationDisplay = styled.Pressable`
  width: 100%;
  height: 135px;
  margin-bottom: 25px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  background:white;
  
`

export const NotificationDisplayTop = styled.View`
  width: 100%;
  height: 90px;
  padding-left: 25px;
  padding-top:15px;
`

export const NotificationDisplayHeader = styled(WorkoutTextSubHeader)`
  font-family: 'Montserrat-EB';
  letter-spacing: 0.5px;
`

export const NotificationDisplayTextTime = styled.Text`
  margin-top:-2px;
  font-size: 42px;
  color:#2d366e;
  font-family: 'Montserrat-EB';
`

export const NotificationDisplayTextDays = styled.Text`
  font-size: 12px;
`

export const NotificationDisplayBottom = styled.View`
  width: 100%;
  height: 50px;
  margin-top:5px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const NotificationDisplayButtonCancel = styled.TouchableOpacity`
  height: 30px;
  width: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top:17.5px;
  right:17.5px;
`

export const NotificationDisplayButtonImg = styled.Image`
  width:100%;
  height:100%;
`

export const NotificationDisplayButtonText = styled.Text`
  font-size: 18px;
`

export default Reminders;
